import type { AllRouteEndpoints } from "../routeTypes";

export const alloysProviderAgenticAppGroupId = "/alloys/:provider/agentic/:app_group_id";

export const alloysAmazonBedrockAgenticExternalId = "/alloys/amazon-bedrock/agentic/:app_group_id/external_id";

// Saving role auth consumes a pending Amazon Bedrock external ID, and disconnecting discards it.
export const deleteAlloysProviderAgenticAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysProviderAgenticAppGroupId,
  alloysAmazonBedrockAgenticExternalId,
];

export const postAlloysProviderAgenticAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysProviderAgenticAppGroupId,
  alloysAmazonBedrockAgenticExternalId,
];

export const postAlloysAmazonBedrockAgenticExternalIdCacheKeys: AllRouteEndpoints[] = [
  alloysAmazonBedrockAgenticExternalId,
];

export const deleteAlloysAmazonBedrockAgenticExternalIdCacheKeys: AllRouteEndpoints[] = [
  alloysAmazonBedrockAgenticExternalId,
];
